module.exports = __webpack_public_path__ + "static/media/PayRoll1.a270522c.png";